<template>
    <tbody>
        <tr>
            <td>
                <span v-if="value.entity">{{ value.entity.id }}</span>
                <span v-else>-</span>
            </td>
            <td>
                <span v-if="value.entity && value.entity.route">
                    <a :href="value.entity.route">{{ value.entity.name }}</a>
                </span>
                <span v-else-if="value.entity">{{ value.entity.name }}</span>
                <span v-else>Unknown</span>
            </td>
            <td>
                <span
                    title="Count"
                    class="label bg-gray"
                    >{{ value.total }}</span
                >
            </td>
            <td>
                <span
                    title="Unique Clickers Percentage"
                    class="label bg-light-blue"
                    >{{ value.unique_percent }}%</span
                >
                <span
                    title="Unique Clickers"
                    class="label bg-aqua-active"
                    >{{ value.unique }}</span
                >
            </td>
            <td>
                <span
                    title="Initial Clickers Percentage"
                    class="label bg-light-blue"
                    >{{ value.initial_percent }}%</span
                >
                <span
                    title="Initial Clickers"
                    class="label bg-aqua-active"
                    >{{ value.initial }}</span
                >
            </td>
            <td>
                <span
                    title="New Clickers"
                    class="label bg-green"
                    >{{ value.new }}</span
                >
            </td>
            <td>
                <span
                    title="New Clickers Revenue Amount"
                    class="label bg-light-blue"
                    >${{ value.new_revenue_amount }}</span
                >
                <span
                    title="New Clickers Revenue Count"
                    class="label bg-aqua-active"
                    >{{ value.new_revenue_count }}</span
                >
            </td>
            <td>
                <BadgeTotal
                    :convert-negative="true"
                    :value="value.new_profit"
                    color="green"
                    symbol="$"
                    title="New Clickers Profit"
                />
                <span
                    title="New Clickers Cost"
                    class="label bg-gray"
                    >${{ value.new_cost }}</span
                >
            </td>
            <td>
                <span
                    title="Repeat Clickers"
                    class="label bg-orange"
                    >{{ value.repeat }}</span
                >
            </td>
            <td>
                <span
                    title="Repeat Clickers Revenue Amount"
                    class="label bg-light-blue"
                    >${{ value.repeat_revenue_amount }}</span
                >
                <span
                    title="Repeat Clickers Revenue Count"
                    class="label bg-aqua-active"
                    >{{ value.repeat_revenue_count }}</span
                >
            </td>
            <td>
                <BadgeTotal
                    :convert-negative="true"
                    :value="value.repeat_profit"
                    color="green"
                    symbol="$"
                    title="Repeat Clickers Profit"
                />
                <span
                    title="Repeat Clickers Cost"
                    class="label bg-gray"
                    >${{ value.repeat_cost }}</span
                >
            </td>
            <td>
                <span
                    title="Non Clickers"
                    class="label bg-red"
                    >{{ value.non }}</span
                >
            </td>
            <td>
                <span
                    title="Non Clickers with Duplicates"
                    class="label bg-gray"
                    >{{ value.with_dupes }}</span
                >
            </td>
            <td class="text-right">
                <span>{{ value.updated_at }}</span>
            </td>
            <td class="text-right">
                <span
                    v-if="value.entity && value.top_cats"
                    class="btn btn-sm btn-info"
                    @click="toggleOpened()"
                >
                    <i
                        v-if="opened"
                        class="fa fa-caret-up"
                    ></i>
                    <i
                        v-else
                        class="fa fa-caret-down"
                    ></i>
                    <span class="sr-only">{{ opened ? 'Close' : 'Open' }}</span>
                </span>
            </td>
        </tr>
        <tr v-if="value.entity && value.top_cats">
            <td
                class="no-padding"
                colspan="15"
            >
                <vue-slide-up-down
                    class="box box-primary no-margin no-border"
                    :active="opened"
                >
                    <div class="box-body table-responsive no-padding">
                        <table class="table table-hover no-margin">
                            <thead>
                                <tr>
                                    <th style="width: 10%">ID</th>
                                    <th style="width: 40%">Category</th>
                                    <th>Clickers Count</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="top in value.top_cats"
                                    :key="top.id"
                                >
                                    <td>{{ top.id }}</td>
                                    <td>
                                        <a :href="top.route">{{ top.name }}</a>
                                    </td>
                                    <td>
                                        <span
                                            title="Percentage"
                                            class="label bg-light-blue"
                                            >{{ top.percentage }}%</span
                                        >
                                        <span
                                            title="Count"
                                            class="label bg-aqua-active"
                                            >{{ top.count }}</span
                                        >
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </vue-slide-up-down>
            </td>
        </tr>
    </tbody>
</template>

<script>
import BadgeTotal from '../subcomponents/BadgeTotal';

export default {
    components: {
        BadgeTotal,
    },
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
    },
    data: function () {
        return {
            opened: false,
        };
    },
    methods: {
        toggleOpened() {
            this.opened = !this.opened;
        },
    },
};
</script>
